import React from "react";
import {
  PHONE_COUNTRY_CODES,
  getPhoneCountryByCode,
  phoneCountryFlagUrl,
} from "../constants/phoneCountryCodes";

/**
 * Country dial-code select with flag image + code.
 * Use inside a phone field group next to the number input.
 */
export default function PhoneCountryCodeSelect({
  name = "countryCode",
  value = "+91",
  onChange,
  disabled = false,
  className = "",
  "aria-label": ariaLabel = "Country code",
}) {
  const selected = getPhoneCountryByCode(value);

  return (
    <span className={`phone-country-code${className ? ` ${className}` : ""}`}>
      <img
        className="phone-country-code__flag"
        src={phoneCountryFlagUrl(selected.iso)}
        alt=""
        width={20}
        height={15}
        loading="lazy"
        decoding="async"
      />
      <select
        name={name}
        value={selected.value}
        onChange={onChange}
        disabled={disabled}
        aria-label={ariaLabel}
      >
        {PHONE_COUNTRY_CODES.map((option) => (
          <option key={`${option.iso}-${option.value}`} value={option.value} title={option.label}>
            {option.flag} {option.value}
          </option>
        ))}
      </select>
    </span>
  );
}
